import React from 'react'
import OpenApiSection from './OpenApiSection'
import ZapierIntegration from './ZapierIntegration'
import ApiContactUS from './contact-us/ApiContactUS'
interface Props {
    activeTab: 'home' | 'openApi' | 'zapier' | 'contact'
    setActiveTab: (tab: 'home' | 'openApi' | 'zapier' | 'contact') => void
}

const ApiDocsContent: React.FC<Props> = ({ activeTab, setActiveTab }) => {
    if (activeTab === 'openApi') return <OpenApiSection />
    if (activeTab === 'zapier') return <ZapierIntegration setActiveTab={setActiveTab} />
    if (activeTab === 'contact') return <ApiContactUS />

    return null // home handled above
}

export default ApiDocsContent
